// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"2":"b79c7b52","14":"4216707b","235":"c83f9d29","291":"dd5ab378","587":"0b7601a7","652":"f610a375","662":"6d358285","715":"bac39da5","751":"7c0fba19","813":"e9d4cab3","822":"2cd0b273"}[chunkId] + ".js";
};